import AccessTimeIcon from '@material-ui/icons/AccessTime';
import EventIcon from '@material-ui/icons/Event';
import GavelIcon from '@material-ui/icons/Gavel';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import BuildIcon from '@material-ui/icons/Build';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DesignServicesIcon from '@material-ui/icons/DesignServices';
import DevicesIcon from '@material-ui/icons/Devices';
import ExploreIcon from '@material-ui/icons/Explore';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LanguageIcon from '@material-ui/icons/Language';
import LaunchIcon from '@material-ui/icons/Launch';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import PublicIcon from '@material-ui/icons/Public';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import SearchIcon from '@material-ui/icons/Search';
import SpeedIcon from '@material-ui/icons/Speed';
import StarsIcon from '@material-ui/icons/Stars';
import SupportAgentIcon from '@material-ui/icons/SupportAgent';
import TimelineIcon from '@material-ui/icons/Timeline';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import WebIcon from '@material-ui/icons/Web';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

export const CHERRY_SOFTWARE_ICONS = {
  verified: VerifiedUserIcon,
  timeline: TimelineIcon,
  team: WorkOutlineIcon,
  schedule: AccessTimeIcon,
  trendingDown: TrendingDownIcon,
  build: BuildIcon,
  web: WebIcon,
  code: CodeIcon,
  autorenew: AutorenewIcon,
  devices: DevicesIcon,
  voice: RecordVoiceOverIcon,
  assignment: AssignmentTurnedInIcon,
  lockOpen: LockOpenIcon,
  stars: StarsIcon,
  search: SearchIcon,
  design: DesignServicesIcon,
  launch: LaunchIcon,
  money: AttachMoneyIcon,
  time: AccessTimeIcon,
  public: PublicIcon,
  support: SupportAgentIcon,
  language: LanguageIcon,
  dashboard: DashboardIcon,
  explore: ExploreIcon,
  speed: SpeedIcon,
  help: HelpOutlineIcon,
  headset: HeadsetMicIcon,
  gavel: GavelIcon,
  menuBook: MenuBookIcon,
  event: EventIcon,
};

export const getCherrySoftwareIcon = (key) => CHERRY_SOFTWARE_ICONS[key] || HelpOutlineIcon;
